import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { Config } from "@config";
import { faCheckCircle as fadCheckCircle } from "@awesome.me/kit-3777c2145e/icons/duotone/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import compact from "lodash/compact";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";

export class KoLead extends AbstractStep {
	protected renderContent(): ReactNode {
		const feedBackEmail = Config.getContactEmail();

		return (
			<>
				<Card.Header>
					<Card.Title className="text-center">Köszönjük, hogy leadtad érdeklődésed!</Card.Title>
				</Card.Header>
				<Card.Body className="d-flex flex-column">
					<div className="mt-auto py-2 text-center">
						<FontAwesomeIcon icon={fadCheckCircle} className="mb-2" size="5x" />
						<br />A Babaváró kalkulátor eredményét elküldtük a megadott email címedre.
					</div>
					<div className="text-center font-weight-bold mb-auto">
						Ha nem érkezik meg a kalkuláció néhány percen belül, ellenőrizd leveleződ „spam” vagy
						„levélszemét” mappáját is!
					</div>
					<div className="text-center mt-auto">
						Amennyiben további kérdésed, észrevételed merülne fel, lépj velünk kapcsolatba a{" "}
						<a className="text-reset text-decoration-underline" href={`mailto:${feedBackEmail}`}>
							{feedBackEmail}
						</a>{" "}
						e-mail címen keresztül!
					</div>
				</Card.Body>
			</>
		);
	}

	protected getClassName(): string {
		return compact([super.getClassName(), "bg-success"]).join(" ");
	}

	protected getComponentName(): string {
		return "KoLead";
	}
}
